import {
  ACKNOWLEDGMENT_TERMS,
  PROGRAM_ITEMS
} from 'components/practice/Settings/components/HealthcareProgram/components/AcknowledgmentsModal/lib/constants';

import AcceptCheckbox from './AcceptCheckbox';
import BulletItem from './BulletItem';
import Divider from './Divider';
import TermsCard from './TermsCard';

const HealthcareProgramTermsSection = ({
  isAdmin,
  isCompleted,
  healthcareAccepted,
  setHealthcareAccepted
}) => {
  return (
    <TermsCard
      title="MediPay Healthcare Program"
      subtitle="Eligibility, patient payment program, and revenue cycle participation:">
      <ul className="flex flex-col gap-2">
        {PROGRAM_ITEMS.map((item) => (
          <BulletItem key={item.title}>
            <span className="font-600">{item.title}.</span> {item.description}
          </BulletItem>
        ))}
      </ul>
      <Divider />
      <ul className="flex flex-col gap-2">
        {ACKNOWLEDGMENT_TERMS.map((term) => (
          <BulletItem key={term.title}>
            <span className="font-600">{term.title}.</span> {term.description}
          </BulletItem>
        ))}
      </ul>
      <Divider />
      <AcceptCheckbox
        id="healthcare-program-accept"
        label={
          <>
            I have read, understand, and accept the MediPay Healthcare Program terms above,
            including the exclusive licensing of forms and workflow, the customized patient payment
            approach, and bundled program participation requirements.
          </>
        }
        isChecked={isCompleted || healthcareAccepted}
        onChange={() => setHealthcareAccepted(!healthcareAccepted)}
        disabled={isCompleted || isAdmin}
        tooltip={
          isAdmin && !isCompleted
            ? 'This step must be completed by a user. Admins cannot acknowledge it.'
            : null
        }
      />
    </TermsCard>
  );
};

export default HealthcareProgramTermsSection;
